import React from 'react'
import Dialog, { Spinner } from '../guest/Dialog'
import s from './AuthWithCard.module.css'
import riderImg from '../../images/auth-with-card/reader.png'
import errorImg from '../../images/auth-with-card/error.png'
import readingImg from '../../images/auth-with-card/reading.png'

export const AuthWithCard = ({ isAuthCard, onClose }) => (
  <Dialog
    isOpen={!!isAuthCard}
    onClose={onClose}
    title='Вход по карте'
    subtitle='Считыватель карт ПЭК'
    className={s.cardDialog}
  >
    <div className={s.reader}>
      <img src={isAuthCard === true ? riderImg : isAuthCard === 'error' ? errorImg : readingImg} alt='' />
    </div>

    {isAuthCard === true ? (
      <>
        <div className={s.state}>Уважаемый пользователь!</div>
        <div className={s.hint}>
          Авторизация по электронной карте возможна только при наличии считывателя, подключенного к Вашему
          компьютеру.
          <br />
          Персональную электронную карту (ПЭК) Вы можете получить в военном комиссариате.
        </div>
      </>
    ) : isAuthCard === 'error' ? (
      <>
        <div className={s.state}>На компьютере отсутствует плагин для работы со считывателем карт ПЭК</div>
        <div className={s.hint}>
          Установите плагин и обновите страницу. Если плагин уже установлен, проверьте, что считыватель подключён к
          компьютеру.
          <br />
          Войти в систему можно по логину и паролю — форма в верхней части страницы.
        </div>
      </>
    ) : (
      <>
        <Spinner />
        <div className={s.state}>Подождите.</div>
        <div className={s.hint}>Выполняется чтение карты...</div>
      </>
    )}
  </Dialog>
)
